import { render, staticRenderFns } from "./TrSelectGame.vue?vue&type=template&id=f255bbd6&scoped=true&"
import script from "./TrSelectGame.vue?vue&type=script&lang=js&"
export * from "./TrSelectGame.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectGame.vue?vue&type=style&index=0&id=f255bbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f255bbd6",
  null
  
)

export default component.exports